import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, TextField, InputAdornment, Button } from '@mui/material';
import { Search, AccountCircle, ShoppingBag, Payment, Security, LocalShipping, Store } from '@mui/icons-material';

import SEO from '../components/SEO';

const HelpCenter = () => {
    const categories = [
        { icon: <AccountCircle fontSize="large" color="primary" />, title: 'Account & Profile', description: 'Manage your account settings and preferences' },
        { icon: <ShoppingBag fontSize="large" color="primary" />, title: 'Orders & Shopping', description: 'Track orders, returns, and shopping guide' },
        { icon: <Payment fontSize="large" color="primary" />, title: 'Payments & Offers', description: 'Payment methods, refunds, and discounts' },
        { icon: <Security fontSize="large" color="primary" />, title: 'Privacy & Security', description: 'Account security and data privacy' },
        { icon: <LocalShipping fontSize="large" color="primary" />, title: 'Delivery & Pickup', description: 'Shipping policies and store pickup' },
        { icon: <Store fontSize="large" color="primary" />, title: 'For Businesses', description: 'Partner support and business tools' },
    ];

    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc', pb: 10 }}>
            <SEO
                title="Help Center"
                description="Find answers to your questions about 10D Stores, including account management, orders, payments, and more."
                canonical="https://10dstores.in/help-center"
            />
            {/* Hero Section */}
            <Box sx={{ backgroundColor: '#1e293b', color: 'white', py: 10, textAlign: 'center' }}>
                <Container maxWidth="md">
                    <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 3 }}>
                        How can we help you?
                    </Typography>
                    <TextField
                        fullWidth
                        placeholder="Search for help topics..."
                        variant="outlined"
                        sx={{
                            backgroundColor: 'white',
                            borderRadius: 2,
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': { border: 'none' },
                            },
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Search color="action" />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Container>
            </Box>

            {/* Categories Grid */}
            <Container maxWidth="lg" sx={{ mt: -5 }}>
                <Grid container spacing={3}>
                    {categories.map((category, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card sx={{ height: '100%', borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.05)', transition: 'transform 0.2s', '&:hover': { transform: 'translateY(-5px)' } }}>
                                <CardContent sx={{ p: 4, textAlign: 'center' }}>
                                    <Box sx={{ mb: 2 }}>{category.icon}</Box>
                                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                                        {category.title}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {category.description}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>

            {/* Contact CTA */}
            <Container maxWidth="md" sx={{ mt: 10, textAlign: 'center' }}>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                    Still need help?
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                    Our support team is available 24/7 to assist you with any issues.
                </Typography>
                <Button variant="contained" color="primary" size="large" href="/contact">
                    Contact Support
                </Button>
            </Container>
        </Box>
    );
};

export default HelpCenter;
